type NoticeKind = "error" | "success";

const STYLES: Record<NoticeKind, string> = {
  error: "border-red-500/20 bg-red-950/30 text-red-300/90",
  success: "border-emerald-500/20 bg-emerald-950/30 text-emerald-300/90",
};

export function Notice({
  kind,
  message,
}: {
  kind: NoticeKind;
  message: string | null;
}) {
  if (!message) return null;

  return (
    <div
      className={`mb-4 rounded-xl border px-4 py-2.5 text-sm ${STYLES[kind]}`}
    >
      {message}
    </div>
  );
}
